// router.js
/* eslint-disable import/prefer-default-export */

import Vue from 'vue';
import Router from 'vue-router';
import Home from '@/pages/Home.vue';
import Products from '@/pages/Products.vue';
import History from '@/pages/History.vue';
import Teaser from '@/components/popins/Teaser.vue';

const mdpConfig = require('../mdp.config');

// Routes names should match the data's config first level key names
// in order to use the shorten $content computed property. ex: "home"
function getRoutes({ locale }, store) { // eslint-disable-line no-unused-vars
  return [
    {
      path: '/history',
      redirect: `/history/${store.state.defaultCollection}`,
    },
    {
      path: '/history/:collectionId',
      name: 'history',
      component: History,
    },
    {
      path: '/',
      redirect: `/${store.state.defaultCollection}`,
    },
    {
      path: '/:collectionId',
      name: 'home',
      component: Home,
      children: [
        {
          path: 'teaser', component: Teaser, name: 'teaser', meta: { name: 'home' },
        },
      ],
    },
    {
      path: '/:collectionId/:id',
      name: 'product',
      component: Products,
    },
    // ################################################################################
    // KEEP THIS LAST
    // This is a catch-all route that redirects to the home page
    // It should be the last route in the array to avoid conflicts with other routes
    // ################################################################################
    {
      path: '*',
      redirect: '/',
    },
  ];
}

Vue.use(Router);
let loaded = false;
export function createRouter(version, store) {
  const config = mdpConfig[version];
  const routes = getRoutes({ ...config, locale: version }, store);
  const scrollMode = window.___scroll_mode || 'auto';
  console.log('⚠️ Scroll mode:', scrollMode);
  return new Router({
    routes,
    scrollBehavior({ name: nameTo }, { name: nameFrom }, savedPosition) {
      const behavior = nameFrom === 'home' ? 'instant' : 'smooth';
      if (nameTo === 'zoom' || nameFrom === 'zoom') {
        return savedPosition;
      }
      if (scrollMode === 'auto') {
        console.info('. Scrolling to selector #app-wrapper with behavior:', behavior);
        return { selector: '#app-wrapper', behavior };
      } else if (scrollMode === 'offset') {
        const appWrapper = document.querySelector('#app-wrapper');
        let offset = 0;
        if (loaded) {
          offset = appWrapper ? appWrapper.getBoundingClientRect().top + window.pageYOffset : 0;
          console.info('. Scroll to offset:', offset, ' -> ', appWrapper.getBoundingClientRect().top, '+', window.pageYOffset);
        } else {
          loaded = true;
          offset = appWrapper ? appWrapper.getBoundingClientRect().top : 0;
          console.info('. Scroll to offset:', offset, ' -> ', appWrapper.getBoundingClientRect().top);
        }
        return { x: 0, y: offset, behavior };
      } else if (parseInt(scrollMode, 10) && parseInt(scrollMode, 10) >= 0) {
        console.info('. Scrolling to fixed offset', parseInt(scrollMode, 10), 'with behavior:', behavior);
        return { x: 0, y: parseInt(scrollMode, 10), behavior };
      } else if (scrollMode === 'top') {
        console.info('. Scrolling to top with behavior:', behavior);
        return { x: 0, y: 0, behavior };
      } else if (typeof scrollMode === 'string' && scrollMode.includes(',')) {
        const parts = scrollMode.split(',');
        const mobile = parseInt(parts[0], 10);
        const desktop = parseInt(parts[1], 10);
        const offset = store.state.isMobile ? mobile : desktop;
        console.info(`. Scrolling to fixed offset per device ${offset} (${store.state.isMobile ? 'mobile' : 'desktop'})`);
        return { x: 0, y: offset, behavior };
      }
      console.info('. Scrolling disabled');

      return false;
    },
  });
}
